export const coupons = [
  {
    goodsName: "리니지 PG개편 테스트 상품 쿠폰 (petaloid)",
    useDate: "2016-05-20 07:40:01.000",
    beginningDate: "2016-04-07 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "8IXQ8SFQNN5SXXTM",
    serviceTypeCode: 7,
    chargeUnit: 100000,
  },
  {
    goodsName: "리니지 PG개편 테스트 상품 쿠폰(petaloid)",
    useDate: "2016-05-20 07:39:52.000",
    beginningDate: "2016-04-07 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "NI1JB2W65GZV664L",
    serviceTypeCode: 7,
    chargeUnit: 105300,
  },
  {
    goodsName: "리니지 PG개편 테스트 상품 쿠폰(petaloid)",
    useDate: "2016-05-20 07:39:43.000",
    beginningDate: "2016-04-07 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "AKXQE5G5UKTK80M3",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "리니지 PG개편 테스트 상품 쿠폰(petaloid)",
    useDate: "2016-05-20 07:39:33.000",
    beginningDate: "2016-04-07 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "R7G3BV28Z67ROX4C",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "리니지 PG개편 테스트 상품 쿠폰(petaloid)",
    useDate: "2016-05-20 07:39:00.000",
    beginningDate: "2016-04-07 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "W8KW6OMLUXN2L8WB",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "리니지 PG개편 테스트 상품 쿠폰(petaloid)",
    useDate: "2016-05-20 07:38:51.000",
    beginningDate: "2016-04-07 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "1D1ACYA68WUCPL4M",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "리니지 PG개편 테스트 상품 쿠폰(petaloid)",
    useDate: "2016-05-20 07:38:43.000",
    beginningDate: "2016-04-07 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "RIBLOBMAVSGYOOBH",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "리니지 PG개편 테스트 상품 쿠폰(petaloid)",
    useDate: "2016-05-20 07:37:23.000",
    beginningDate: "2016-04-07 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "H7E5PP9GWHCFFPB5",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "리니지 PG개편 테스트 상품 쿠폰(petaloid)",
    useDate: "2016-05-20 07:37:03.000",
    beginningDate: "2016-04-07 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "7EM6QDC2D3CE29TD",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "2014 지스타 LE CBT PASS",
    useDate: "2016-05-20 06:37:43.000",
    beginningDate: "2016-05-19 15:00:00.000",
    closingDate: "2016-06-19 14:59:59.000",
    couponKey: "SB292RUMK4O5H72M",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "2014 지스타 LE CBT PASS",
    useDate: "2016-05-20 06:34:00.000",
    beginningDate: "2014-11-10 15:00:00.000",
    closingDate: "2099-01-11 14:59:59.000",
    couponKey: "3IH0A4QM5ZXY4O0K",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "펀플테스트등록 쿠폰",
    useDate: "2016-05-20 02:08:21.000",
    beginningDate: "2015-06-21 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "W2OSFQ2ZME08ZPZF",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "펀플테스트등록 쿠폰",
    useDate: "2016-05-20 02:08:21.000",
    beginningDate: "2015-06-21 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "GO0AZECWE4CLJPE0",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "펀플테스트등록 쿠폰",
    useDate: "2016-05-20 02:08:21.000",
    beginningDate: "2015-06-21 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "MSSNZD76EWF1CJTA",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
  {
    goodsName: "펀플테스트등록 쿠폰",
    useDate: "2016-05-20 02:08:21.000",
    beginningDate: "2015-06-21 15:00:00.000",
    closingDate: "2016-07-31 14:59:59.000",
    couponKey: "WYSYUD4K2ITFY70S",
    serviceTypeCode: 7,
    chargeUnit: 0,
  },
];
